import EventProcessor from "../../event/EventProcessor"
import EvaluateResponse from "../EvaluateResponse"
import EvaluationEventFactory from "./EvaluationEventFactory"

export default class EvaluationEventRecorder {
  constructor(private readonly eventFactory: EvaluationEventFactory, private readonly eventProcessor: EventProcessor) {}

  record(response: EvaluateResponse): void {
    this.eventFactory.create(response).forEach((event) => this.eventProcessor.process(event))
  }
}
